export const CRASH_FORMAT = 1;

export type CrashKind =
  | 'js'
  | 'error'
  | 'java'
  | 'ndk'
  | 'anr'
  | 'renderer_gone'
  | 'oom_exit'
  | 'anr_exit'
  | 'abnormal_exit';

export type CrashMechanism = 'onerror' | 'unhandledrejection' | 'manual' | 'checkpoint' | 'console';

export type BreadcrumbType = 'screen' | 'http' | 'ws' | 'console' | 'level' | 'dialog' | 'app';

export type CrashPlatform = 'android' | 'ios' | 'web';

export interface CrashBreadcrumb
{
  at: string;
  type: BreadcrumbType;
  data: string;
}

export type CheckpointName =
  | 'process_start'
  | 'webview_loaded'
  | 'bootstrap_js'
  | 'consent_resolved'
  | 'logged_in'
  | 'configs_ready'
  | 'levels_ready'
  | 'menu_shown'
  | 'level_started'
  | 'in_game'
  | 'backgrounded'
  | 'foreground'
  | 'clean_exit';

export interface CrashCheckpoint
{
  name: CheckpointName;
  at: string;
  session_id: string | null;
  seq: number;
}

export interface CrashIdentityData
{
  user_id: string | null;
  device_id: string | null;
  session_id: string | null;
  analytics_id: string | null;
}

export interface CrashAppInfo
{
  version: string | null;
  version_code: number | null;
  build_id: string;
  native_build_id: string | null;
  env: string;
  is_prod: boolean;
  platform: CrashPlatform;
}

export interface CrashDeviceInfo
{
  user_agent?: string;
  gpu?: string | null;
  screen?: [ number, number ];
  dpr?: number;
  js_heap_used_mb?: number | null;
  js_heap_limit_mb?: number | null;
  network?: string | null;
  online?: boolean;
  [key: string]: unknown;
}

export interface CrashException
{
  type: string;
  message: string;
  stack: string | null;
  cause: CrashException | null;
}

export interface CrashSnapshot
{
  [key: string]: unknown;
}

export interface CrashEvent
{
  format: typeof CRASH_FORMAT;
  event_id: string;
  kind: CrashKind;
  occurred_at: string;
  handled: boolean;
  mechanism: CrashMechanism;
  app: CrashAppInfo;
  identity: CrashIdentityData;
  checkpoint: { name: string; at: string } | null;
  screen: string | null;
  device: CrashDeviceInfo;
  exception: CrashException | null;
  breadcrumbs: CrashBreadcrumb[];
  snapshot: CrashSnapshot | null;
  tags: Record<string, string>;
  fingerprint: string[] | null;
  extra: Record<string, unknown> | null;
  dropped: number;
}
